export { HouseSignalIcon } from './HouseSignalIcon'
